var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"site-content",class:{ 'site-content--tabs': _vm.$route.meta.isTab }},[_c('el-card',{staticClass:"relative",attrs:{"body-style":_vm.siteContentViewHeight}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }